import { useEffect, useRef, useState } from 'react';
import { authManager } from './authManager';
export const useAuthData = () => {
    const [authData, setAuthData] = useState(null);
    const [expired, setExpired] = useState(true);
    const timeoutRef = useRef(null);
    useEffect(() => {
        const getAuthData = async () => {
            const authData = await authManager.getAuthData();
            setAuthData(authData);
            setExpired(false);
            timeoutRef.current = setTimeout(() => {
                setExpired(true);
            }, authManager.accessTokenExpiresInMs());
        };
        getAuthData();
        return () => {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
        };
    }, [expired]);
    return authData;
};
//# sourceMappingURL=useAuthData.js.map